module.exports = __webpack_public_path__ + "v-orange-ddf372b8.svg";